import React, { Component } from 'react';
import RequestManager from '../../requests/RequestManager';
import activitiesTask from '../../requests/tasks/social/activities/activitiesTask';
import SocialActivity from '../../components/Social/SocialActivity';
import Pagination from '../../components/Social/Pagination';
import { showModal, AAF_MODAL_ERROR } from '../../actions/modal';
import { connect } from 'react-redux';

class SocialActivities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activities: null,
            skip: 0,
            limit: 15,
            page: 1,
        }

    }

    getData = (e, d) => {
        e.preventDefault();
        let page = 1 + (d.skip / this.state.limit);

        let parameters = [{
            skip: d.skip,
            limit: d.limit,
            gameId: this.props.gameId,
        }, this.props.gamificationId ];

        const par = new activitiesTask(...parameters);
        return RequestManager.addRequest(par)
        .then((data) => {
            this.setState({
                activities: data.data,
                skip: parameters[0].skip,
                limit: parameters[0].limit,
                page,
            }, () => { window.SpatialNavigation.focus('.activities .focusable') })
        })
        .catch((e) => {
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {
                    content: e,
                }
            }
            this.props.showModal(modal);
        })
    }

    componentDidMount() {
        let p = [{
            skip: this.state.skip,
            limit: this.state.limit,
            gameId: this.props.gameId,
        }, this.props.gamificationId ]

        let params = new activitiesTask(...p);
        RequestManager.addRequest(params)
        .then((data) => {
            if(data.data)
                this.setState({ activities: data.data })
        })
        .catch((e) => {
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {
                    content: e,
                }
            }
            this.props.showModal(modal);
        })

    }

    render() {
        if(!this.state.activities) return null;
        const activities = Object.assign([], this.state.activities);

        const activitiesComponent = activities.map((it, i) => {
            const className = i === 0 ? '.elementopredeterminado' : '';
            const focusUp = i === 0 ?
              '.social .seens .card .focusable'
            : `#social-activity-${i - 1} .focusable`;
            return (<SocialActivity
                key={i}
                keyNumber={i}
                id={`social-activity-${i}`}
                className={className}
                activity={it}
                userSocial={this.props.userSocial}
                translations={this.props.translations}
                isCurrentUser={this.props.isCurrentUser}
                gameId={this.props.gameId}
                focusUp={focusUp}
            />)
        })

        return(<div className="activities">
            <div className="activities-title ribbon-title">
                { this.props.translations.get('social_activity', 'Mi Actividad')}
            </div>
            <div className="activities_div">
                { activitiesComponent }
            </div>
            <Pagination
                skip={this.state.skip}
                limit={this.state.limit}
                page={this.state.page}
                activities={activities}
                getData={this.getData}
                translations={this.props.translations}
            />
        </div>);
    }

}

const mapStateToProps = (state) => {
    return { user: state.user }
}

export default connect(mapStateToProps, { showModal })(SocialActivities);



// WEBPACK FOOTER //
// ./src/containers/Social/SocialActivities.jsx